/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TagReference,
    TagReferenceFromJSON,
    TagReferenceFromJSONTyped,
    TagReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetUpdate
 */
export interface AssetUpdate {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AssetUpdate
     */
    customFields: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Array<TagReference>}
     * @memberof AssetUpdate
     */
    tags: Array<TagReference>;
    /**
     * 
     * @type {number}
     * @memberof AssetUpdate
     */
    workflowState?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetUpdate
     */
    timecode?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetUpdate
     */
    set?: number | null;
}

export function AssetUpdateFromJSON(json: any): AssetUpdate {
    return AssetUpdateFromJSONTyped(json, false);
}

export function AssetUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customFields': json['custom_fields'],
        'tags': ((json['tags'] as Array<any>).map(TagReferenceFromJSON)),
        'workflowState': !exists(json, 'workflow_state') ? undefined : json['workflow_state'],
        'timecode': !exists(json, 'timecode') ? undefined : json['timecode'],
        'set': !exists(json, 'set') ? undefined : json['set'],
    };
}

export function AssetUpdateToJSON(value?: AssetUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_fields': value.customFields,
        'tags': ((value.tags as Array<any>).map(TagReferenceToJSON)),
        'workflow_state': value.workflowState,
        'timecode': value.timecode,
        'set': value.set,
    };
}


